import { frontEndConstants } from '../constant/front-end-constant';
import { history } from '../../helper/history';
import { musicDirectorService } from 'services/musicDirector';
import { alertActions } from './alert-actions';
export const musicDirectorActions = {
	login,
    logout,
    getAdudicators,
    getAdudicatorsRecordings,
    forgetUsername
}

function login(username) {
    return dispatch => {
        dispatch(request({ username }));
        musicDirectorService.login(username)
            .then(
                musicDirector => {
                    // console.log('musicDirector data', musicDirector);
                    dispatch(success(musicDirector));
                    history.push('/Dashboard');
                },
                error => {
                    console.log('error login', error);
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(username) { return { type: frontEndConstants.LOGIN_MUSIC_DIRECTOR_REQUEST, payload:username } }
    function success(musicDirector) { return { type: frontEndConstants.LOGIN_MUSIC_DIRECTOR_SUCCESS, payload:musicDirector } }
    function failure(error) { return { type: frontEndConstants.LOGIN_MUSIC_DIRECTOR_FAILURE, payload:error } }
}


function forgetUsername(email) {
    return dispatch => {
        dispatch(request({ email }));
        musicDirectorService.forgetUsername(email)
            .then(
                response => {
                    // console.log('musicDirector data', musicDirector);
                    dispatch(success(response.message));
                    dispatch(alertActions.success(response.message));
                    //history.push('/Dashboard');
                },
                error => {
                    console.log('error login', error);
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(email) { return { type: frontEndConstants.FORGET_MUSIC_DIRECTOR_REQUEST, payload:email } }
    function success(response) { return { type: frontEndConstants.FORGET_MUSIC_DIRECTOR_SUCCESS, payload:response } }
    function failure(error) { return { type: frontEndConstants.FORGET_MUSIC_DIRECTOR_FAILURE, payload:error } }
}

function logout() {
    musicDirectorService.logout();
    return { type: frontEndConstants.LOGOUT_MUSIC_DIRECTOR };
}


function getAdudicators(musicDirectorData){
    return dispatch => {
        dispatch(request());
        musicDirectorService.getAdudicators(musicDirectorData)
            .then(
                response => {
                    dispatch(success(response));
                    // history.push('/Dashboard');
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() { return { type: frontEndConstants.GET_ADJUDICATORS_REQUEST } }
    function success(response) { return { type: frontEndConstants.GET_ADJUDICATORS_SUCCESS, payload:response } }
    function failure(error) { return { type: frontEndConstants.GET_ADJUDICATORS_FAILURE, payload:error } }
}

function getAdudicatorsRecordings(adjudicatorObject, page){
    return dispatch => {
        dispatch(request());
        musicDirectorService.getAdudicatorsRecordings(adjudicatorObject, page)
            .then(
                response => {
                    dispatch(success(response));
                    // history.push('/Dashboard');
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() { return { type: frontEndConstants.GET_ADJUDICATORS_RECORDINGS_REQUEST } }
    function success(response) { return { type: frontEndConstants.GET_ADJUDICATORS_RECORDINGS_SUCCESS, payload:response } }
    function failure(error) { return { type: frontEndConstants.GET_ADJUDICATORS_RECORDINGS_FAILURE, payload:error } }
}


// WEBPACK FOOTER //
// ./src/redux/actions/music-director-action.jsx